import { Clickable } from '@carvana/merch-components';
import { useContext } from 'react';
import { PickupAndDeliveryState } from '~/components/vdp/PickupAndDelivery';
import ModalContext from '~/context/vdp/ModalContext';
import { DeliveryPickup } from '~/contracts/common';
import getAsSoonAsText from '~/utilities/date/getAsSoonAsText';
import { GridContainer, Header, Link, Text } from './Availability.styles';
import getIconToUse from './getIconToUse';

type OwnProps = {
  pickup?: Partial<DeliveryPickup>;
  componentState: PickupAndDeliveryState;
};

const PickupBox = ({ componentState, pickup = {} }: OwnProps) => {
  const { asSoonAsText, utcSoonestDateTimeIso, locationCity, locationState } =
    pickup;
  const { setGeolocationModalOpen } = useContext(ModalContext);
  const pickupDate = getAsSoonAsText(asSoonAsText, utcSoonestDateTimeIso);
  const IconToUse = getIconToUse(componentState, 'pickup');

  return (
    <GridContainer>
      <IconToUse className="mx-auto" />
      <Header>Pickup {pickupDate}</Header>
      <Text>
        <span className="text-blue-6">Pick it up</span> from our {locationCity}{' '}
        location
      </Text>
      <Clickable
        data-analytics-id="Earliest Pickup open Geolocation Modal"
        onClick={() => {
          setGeolocationModalOpen(true);
        }}
        element={Link}
      >
        {locationCity}, {locationState}
      </Clickable>
    </GridContainer>
  );
};

export default PickupBox;
